import React from 'react';
export function Hero() {
  return <section className="bg-gradient-to-b from-surface to-white py-20" data-id="element-619">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-620">
        <div className="text-center" data-id="element-621">
          <div className="w-16 h-16 bg-surface border border-neutral rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-622">
            <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-623">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" data-id="element-624" />
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-ink mb-6 load-fade-in-up stagger-2" data-id="element-625">
            Project Management
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed load-fade-in-up stagger-3" data-id="element-626">
            Structured delivery with clear milestones, transparent
            communication, and on-time execution.
          </p>
        </div>
      </div>
    </section>;
}